const authConfig = {
  API_URL: process.env.REACT_APP_API_URL,
  CONTEXT_PATH: process.env.REACT_APP_CONTEXT_PATH,
}

export { authConfig };